module.exports = __webpack_public_path__ + "img/assets/select/orange-brush@2x.59e02defd4b08574abfd8b1b451110f8.webp";